import LocationAutocomplete from './LocationAutocomplete'

export default LocationAutocomplete
